var enums = {
  opp_naics_code: [
    {
      name: "72: ACCOMODATION FOOD SERVICES",
      code: 100000000,
      alternates: ["72"],
    },
    {
      name: "56: ADMIN SUPPORT WASTE MANAGEMENT REMEDIATION SERV",
      code: 100000001,
      alternates: ["56"],
    },
    {
      name: "11: AGRICULTURE FORESTRY FISHING HUNTING",
      code: 100000002,
      alternates: ["11"],
    },
    {
      name: "71: ARTS ENTERTAINMENT RECREATION",
      code: 100000003,
      alternates: ["71"],
    },
    {
      name: "55: MANAGEMENT OF COMPANIES",
      code: 100000009,
      alternates: ["55"],
    },
    {
      name: "23: CONSTRUCTION",
      code: 100000004,
      alternates: ["23"],
    },
    {
      name: "61: EDUCATION",
      code: 100000005,
      alternates: ["61"],
    },
    {
      name: "52: FINANCE INSURANCE",
      code: 100000006,
      alternates: ["52"],
    },
    {
      name: "62: HEALTHCARE SOCIAL SERVICES",
      code: 100000007,
      alternates: ["62"],
    },
    {
      name: "51: TECHNOLOGY INFORMATION",
      code: 100000008,
      alternates: ["51"],
    },
    {
      name: "31-33: MANUFACTURING",
      code: 100000010,
      alternates: ["31", "32", "33"],
    },
    {
      name: "21: MINING QUARRYING OIL GAS EXTRACTION",
      code: 100000011,
      alternates: ["21"],
    },
    {
      name: "54: PROFESSIONAL TECHNICAL SERVICES",
      code: 100000013,
      alternates: ["54"],
    },
    {
      name: "92: PUBLIC ADMINISTRATION",
      code: 100000014,
      alternates: ["92"],
    },
    {
      name: "53: REAL ESTATE",
      code: 100000015,
      alternates: ["53"],
    },
    {
      name: "44-45: RETAIL",
      code: 100000016,
      alternates: ["44", "45"],
    },
    {
      name: "81: SERVICE",
      code: 100000012,
      alternates: ["81"],
    },
    {
      name: "48-49: TRANSPORTATION WAREHOUSING",
      code: 100000017,
      alternates: ["48", "49"],
    },
    {
      name: "22: UTILITIES",
      code: 100000018,
      alternates: ["22"],
    },
    {
      name: "42: WHOLESALE",
      code: 100000019,
      alternates: ["42"],
    },
  ],
  opp_company_type: [
    {
      name: "Corporation",
      code: 4,
    },
    {
      name: "General Partnership",
      code: 3,
    },
    {
      name: "Limited Liability Company (LLC)",
      code: 7,
    },
    {
      name: "Limited Partnership",
      code: 6,
    },
    {
      name: "Non-Profit",
      code: 5,
    },
    {
      name: "Sole Proprietorship/Individual",
      code: 1,
    },
  ]
};
export default enums;



// WEBPACK FOOTER //
// ./src/services/enums.js